/**
 * Manual ad-hoc initiation reasons (runtime Create Manual Form).
 * Not automatic system events.
 */
export const MANUAL_TRIGGER_OPTIONS = [
  {
    value: "AD_HOC_STORAGE_INSPECTION",
    label: "Ad-hoc storage inspection",
  },
  {
    value: "TEMPERATURE_INVESTIGATION",
    label: "Temperature investigation",
  },
  {
    value: "IMP_ACCOUNTABILITY_CHECK",
    label: "IMP accountability check",
  },
  {
    value: "PHARMACY_DEVIATION_ASSESSMENT",
    label: "Pharmacy deviation assessment",
  },
  {
    value: "CORRECTIVE_FOLLOW_UP",
    label: "Corrective follow-up",
  },
  {
    value: "REQUESTED_REVIEW",
    label: "Requested review",
  },
  { value: "OTHER", label: "Other" },
];

export const WEEKDAY_OPTIONS = [
  { value: "1", label: "Monday" },
  { value: "2", label: "Tuesday" },
  { value: "3", label: "Wednesday" },
  { value: "4", label: "Thursday" },
  { value: "5", label: "Friday" },
  { value: "6", label: "Saturday" },
  { value: "7", label: "Sunday" },
];

export const REPORTING_PERIOD_OPTIONS = [
  { value: "PREVIOUS_CALENDAR_MONTH", label: "Previous calendar month" },
  { value: "CURRENT_PERIOD", label: "Current period" },
  { value: "NONE", label: "None" },
];

export function dayOfMonthOptions(max = 28) {
  return Array.from({ length: max }, (_, i) => ({
    value: String(i + 1),
    label: String(i + 1),
  }));
}
